import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Radio, RadioGroup, FormControl, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import ComponentHeaderTitles from '../ComponentHeaderTitles';
import ComponentHeaderDescriptions from '../ComponentHeaderDescriptions';

const StyledCard = styled(Card)({
    marginBottom: "1rem",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    "&.selected": {
        backgroundColor: "#f0f0f0",
    },
});

function VerbruikSelection({ options, verbruikEstimaterRequired, setVerbruikEstimaterRequired }) {
    const [selectedOption, setSelectedOption] = useState(verbruikEstimaterRequired ? 'Nee' : 'Ja');

    useEffect(() => {
        setVerbruikEstimaterRequired(selectedOption === 'Nee');
    }, [selectedOption, setVerbruikEstimaterRequired]);

    const handleCardClick = (option) => {
        setSelectedOption(option);
    };

    const getOptionText = (option) => {
        if (option === 'Ja') {
            return 'Ja, ik vul zelf mijn verbruik in';
        } else if (option === 'Nee') {
            return 'Nee, help mij met inschatten';
        }
    };

    const optionIcons = {
        Ja: <div className="icon-as-bekend icon-size"></div>, // vervang dit met je eigen icon component of markup
        Nee: <div className="icon-as-onbekend icon-size"></div>, // vervang dit met je eigen icon component of markup
    };

    return (
        <div>
            <ComponentHeaderTitles title="Weet je het energieverbruik?"/>
            <ComponentHeaderDescriptions description="Vul zelf je jaarverbruik in op basis van je huidige verbruik. Of schat je verbruik via een paar vragen."/>
            <FormControl component="fieldset">
                <RadioGroup
                    name="verbruik"
                    value={selectedOption}
                    onChange={(e) => handleCardClick(e.target.value)}
                >
                    {options.map((option, index) => (
                        <StyledCard
                            key={index}
                            className={selectedOption === option ? 'selected' : ''}
                            onClick={() => handleCardClick(option)}
                        >
                            <CardContent>
                                <FormControlLabel
                                    value={option}
                                    control={<Radio />}
                                    label={
                                        <div className="icon-text-wrapper">
                                            {optionIcons[option]} {/* Hier voeg je het icoon toe */}
                                            <Typography variant="h5" component="h2">
                                                {option === 'Ja' ? 'Ja, ik vul zelf mijn verbruik in' : 'Nee, help mij met inschatten'}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </CardContent>
                        </StyledCard>
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    );
}
VerbruikSelection.displayName = 'VerbruikSelection';
export default VerbruikSelection;
